import { createSelector } from 'reselect';

import { RootState } from '../types';

export const menuSelector = (state: RootState) => state.menu ?? {};

export const menuOpenSelector = createSelector(
  menuSelector,
  ({ open }) => open
);

export const menuWidgetSelector = createSelector(
  menuSelector,
  ({ widget }) => widget
);
